module.exports = __webpack_public_path__ + "img/ZWF_Leo_Ana.62ac65f5.jpg";